import { useEffect, useRef, useState } from "react"
import LineChart from "../../Components/highChart/new/NewLineChartGraficoElecciones"
import { listaColoresChart } from "../../Components/shared/colores";
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { getCategoriaPrioridadesCiudadanas } from '../../services/service';
import highchartsSeriesLabel from 'highcharts/modules/series-label'; // Importar el módulo series-label
import Highcharts from 'highcharts'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Loading from "../../Components/shared/Loading/Loading";


const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 12,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 11 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition, fontSize: 14 };
    }
};




const GraficoPrioridadesCiudadanasGobierno = () => {
    const divRef = useRef(null);

    const [categories, setCategories] = useState([])
    const [data, setdata] = useState({ tituloProps: '', subtitleProps: '', selectValueProsp: [], formatDataStringData: '%', disableFilterProps: true, numDecimalProps: 0, pieTextProps: '', showPieTextInGraph: true, showLineTop: true, showSeries: true })
    const [arrayColores, setArrayColores] = useState(listaColoresChart);
    const [apiData, setApiData] = useState([]);
    const [stateLoading, setstateLoading] = useState(false)

    const [valueData, setValuesData] = useState<any[]>()
    const [selectedOptionsEmpresa, setSelectedOptionsEmpresa] = useState<any>();
    const [valueOptionsEmpresa, setvalueOptionsEmpresa] = useState<any>([{ value: '1', label: 'Cadem' }, { value: '2', label: 'Cep' }]);

    const [selectedOptionsCandidatos, setSelectedOptionsCandidatos] = useState<any>([]);
    const [valueOptionsCandidatos, setvalueOptionsCandidatos] = useState<any>([]);
    const [pieTextState,setPieTextState] = useState('')

    highchartsSeriesLabel(Highcharts);


    const exportToPDF = () => {
        const element = document.getElementById('element-to-export');
        //@ts-ignore
        html2canvas(divRef.current).then(canvas => {
            const pdf = new jsPDF('p', 'mm', 'a4');
            pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 210, 100);
            pdf.save('Elecciones_presidenciales_2025.pdf');
        });
    }
    const { tituloProps, subtitleProps, selectValueProsp, formatDataStringData, disableFilterProps,
        numDecimalProps,
        pieTextProps,
        showPieTextInGraph,
        showLineTop,
        showSeries } = data


    const handleCapture = () => {
        if (divRef.current) {
            html2canvas(divRef.current).then(canvas => {
                // Generar imagen base64
                const imgData = canvas.toDataURL('image/png');
                // Crear un enlace para descargar la imagen
                const link = document.createElement('a');
                link.download = 'PrioridadesCiudadanas.png';
                link.href = imgData;
                link.click();
            });
        }
    };
    const exportExcel = (params: any) => {
        //Creo un nuevo excel
        const wb = XLSX.utils.book_new();

        //Se setean los datos al formato para el excel
        const data = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));

        //Se crea una pagina por cada cada grafico con sus respectivos datos
        XLSX.utils.book_append_sheet(wb, data, 'Grafico');

        //Se descarga el excel
        XLSX.writeFile(wb, "Data " + "Grafico" + ".xlsx")
    }
    const setDataGraficoForExcel = (data: any) => {
        let arrayAux: any = [];

        const newvalue = data.map((item: any) => {
            let obj: any = {}

            item.value.forEach((itemData: any) => {
                obj[itemData.Empresa] = itemData.Categoria
            })

            return { empresa: selectedOptionsEmpresa.label, categoria: item.label, ...obj }


        })

        console.log('newvalue', newvalue);


        return newvalue
    }


    const onChangeSelectEmpresa = async (value: any) => {
        setSelectedOptionsEmpresa(value)

        if(value.value === '1'){
            setPieTextState('A su juicio, ¿En cuál de las siguientes áreas el Gobierno del Presidente Boric debería dedicar mayor esfuerzo durante 2023 / 2024? % Total menciones.')
        }else{
            setPieTextState('¿Cuáles son los 3 problemas a los que debería dedicar el mayor esfuerzo en solucionar el gobierno? %Total menciones.')
        }
        console.log('emprena', value.value);
        // setstateLoading(true)
        setCategories([])
        setValuesData([])
        setSelectedOptionsCandidatos([])
        cargarGrafico(parseInt(value.value))



    }

    const selectEscenario = async (value: any) => {
        setSelectedOptionsCandidatos(value)
    
        let labels: any = []
        const data: any = []
        //return {name:itemData.candidatos,data:data}
        value.forEach((item: any) => {
            const categoria:any ={name:item.label,data:[]}
            const label:any =[]
            item.value.forEach((itemData: any) => {
                categoria.data.push(itemData.Categoria)
                label.push(itemData.Empresa)
            })
         
            data.push(categoria)
            labels = label
        })


        setCategories(labels)
        setValuesData(data)


    }
    const cargarGrafico = (id_categoria: number) => {

        getCategoriaPrioridadesCiudadanas(id_categoria).then((r: any) => {

            const listCategory = r.data.data.data.map((item: any) => {
                return { value: item.Valores, label: item.Categoria }
            })

            setvalueOptionsCandidatos(listCategory)
            selectEscenario([listCategory[0],listCategory[1],listCategory[2]])
            setApiData(listCategory)

            
        })



    }
    const cargarDats = async () => {
         
        onChangeSelectEmpresa({ value: '1', label: 'Cadem' })
    }



    useEffect(() => {

        cargarDats()





    }, [])



    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className={`d-flex justify-content-center border-top-graph`} >
                        <div className="bg-body rounded chart-content mt-3">
                            {stateLoading ? <Loading loading={stateLoading} /> : null}

                            <div className="d-flex gap-2">
                                <div className="flex1">
                                    <Select
                                        className="react-select-container flex1"
                                        classNamePrefix="react-select "
                                        placeholder="Empresa"
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        options={valueOptionsEmpresa}
                                        //@ts-ignore
                                        onChange={(e) => onChangeSelectEmpresa(e)}
                                        value={selectedOptionsEmpresa}
                                    />
                                </div>
                                <div className="flex1">
                                    <Select
                                        className="react-select-container flex1"
                                        classNamePrefix="react-select "
                                        placeholder="Categoría"
                                        isMulti
                                        styles={customStyles}
                                        closeMenuOnSelect={true}
                                        options={valueOptionsCandidatos}
                                        onChange={(e) => selectEscenario(e)}
                                        value={selectedOptionsCandidatos}
                                    />
                                </div>



                            </div>

                            <div ref={divRef} className='mt-3 container-graphLine'>
                                <LineChart
                                    allData={valueData}
                                    title={'Prioridades ciudadanas para el gobierno'}
                                    subtitle={''}
                                    numDecimalProps={numDecimalProps}
                                    pieTextProps={pieTextState}
                                    showSeries={showSeries}
                                    formatDataStringData={formatDataStringData}
                                    showPieTextInGraph={showPieTextInGraph}
                                    labels={categories}
                                    colores={arrayColores}
                                    exportExcel={exportExcel}
                                    exportarImagen={handleCapture}
                                    activeButton={true}
                                />
                            </div>

                        </div>
                        {/* <ChartV5 /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GraficoPrioridadesCiudadanasGobierno